import { z } from "zod"

import { kWkWhSchema } from "./units"

export const calculatedCostSummarySchema = z.object({
  ELECTRICITY: kWkWhSchema.optional().nullable(),
  subTotalCost: z.number(),
  taxCost: z.number(),
  totalCost: z.number(),
  adjustedTotalCost: z.number(),
  kWh: z.number(),
  kW: z.number(),
  preTaxMinimumCost: z.number().optional().nullable(),
  import: z.number().optional().nullable(),
  export: z.number().optional().nullable(),
  nonBypassableCost: z.number().optional().nullable(),
})

export type CalculatedCostSummary = z.infer<typeof calculatedCostSummarySchema>
